import React, { Component } from "react";
import './contact.css';
import { FormattedMessage } from 'react-intl';

class Contact extends Component {

  render() {
    return (
      <div>

        <div className="row" >
          <img className="contact-swirl" src="img/contact/swirl-5.png" alt="Swirl" />

          <div className="col-sm-2 col-md-3 col-lg-3 col-xl-4">
          </div>

          <div className="col-sm-8 col-md-6 col-lg-6 col-xl-4 contact-card-outside">

            <div className="contact-card">
              <div className="row" >
                <img className="contact-logo-image" src="img/logo.png" alt="Logo" />
              </div>
              <div className="row" >
                <span className="contact-quote" >Create brilliant memories</span>
              </div>
              <div className="row" >
                <h1 className="contact-header"><FormattedMessage id={'contact.info'} /></h1>
              </div>
              <div className="row" >
                <div className="contact-buttons" >
                  <div className="contact-email">
                    <a href="mailto:ByThirsa<info@bythirsa.com>" className="btn btn-email"><span><i className="fas fa-envelope"></i> Mail Thirsa</span></a>
                  </div>
                  <div className="contact-social">
                    <div >
                      <a href="https://www.facebook.com/ByThirsa-398355200201420/" rel="noopener noreferrer" target="_blank" className="btn btn-social btn-facebook"><img src="img/contact/facebook.svg" alt="Facebook"></img></a>
                    </div>
                    <div >
                      <a href="https://www.instagram.com/bythirsa/" target="_blank" rel="noopener noreferrer" className="btn btn-social btn-instagram"><img src="img/contact/instagram.svg" alt="Instagram"></img></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div className="col-sm-2 col-md-3 col-lg-3 col-xl-4">
          </div>
        </div>

        <div className="row copyright" >
          <div className="col-sm-12">
            <p><FormattedMessage id={'contact.copyright'} /></p>
          </div>
        </div>

      </div>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/contact/contact.js